import React from 'react';
import { Modal, Button } from 'semantic-ui-react';

const RejectionSuccessModal = ({ open, onClose, isApprover, requestData }) => {
    return (
        <Modal open={open} onClose={onClose} size="small">
            <Modal.Header className="bg-red-50 text-red-700">
                Request Rejected Successfully
            </Modal.Header>
            <Modal.Content>
                <div className="flex flex-col gap-4">
                    <p>
                        You have successfully rejected the request{' '}
                        {requestData?.id && <strong>({requestData.id})</strong>}.
                    </p>
                    <p>
                        {isApprover
                            ? 'An email notification has been sent to the form filler.'
                            : 'An email notification has been sent to the form filler.'}
                    </p>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color="red" onClick={onClose}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default RejectionSuccessModal;